import React, { useState, useRef, useEffect } from "react";
import "./../NewArticle/TextEditor.css";
import InputWlabel from "../Inputs/InputWlabel";
import { useAdminContext } from "./../../Context/AdminContext";
import { useDBContext } from "./../../Context/DBcontext";
import GalleryModal from "../NewArticle/GalleryModal";
import {
  collection,
  getFirestore,
  getDoc,
  doc,
  getDocs,
  query,
  where,
} from "firebase/firestore"; // Asegúrate de importar lo necesario de Firebase

export default function EditArticle({
  save,
  saveDraft,
  savingDraft,
  savedDraft,
  adding,
  added,
  articleFetched,
  title,
  category,
  author,
  subtitle,
  date,
  time,
  metaurl,
  related,
  tags,
  content,
  cover,
  position,
  id,
  enabled,
  created,
}) {
  const db = getFirestore();

  const editorRef = useRef(null);

  const {
    uploadedShop,
    uploadedZip,
    uploadingZip,
    bigImg,
    alreadyExists,
    handleUploadShopImage,
    handleChange,
  } = useAdminContext();

  const {
    getArticles,
    getAuthors,
    getCategories,
    getDrafts,
    articles,
    drafts,
    categories,
    authors,
  } = useDBContext();

  useEffect(() => {
    if (articles.length === 0) {
      getArticles();
    }

    if (drafts.length === 0) {
      getDrafts();
    }

    if (categories.length === 0) {
      getCategories();
    }

    if (authors.length === 0) {
      getAuthors();
    }
  }, []);

  const [render, setRender] = useState(0);

  const [newCategory, setNewCategory] = useState(category);
  const [newSubtitle, setNewSubtitle] = useState(subtitle);
  const [newTitle, setNewTitle] = useState(title);
  const [newAuthor, setNewAuthor] = useState(author);
  const [newDate, setNewDate] = useState(date);

  const [newTime, setNewTime] = useState(time);
  const [newMetaurl, setNewMetaurl] = useState(metaurl ? metaurl : "");
  const [newRelated, setNewRelated] = useState(null);
  const [newTagsArr, setNewTagsArr] = useState(tags);
  const [newEnabled, setNewEnabled] = useState(enabled);
  const [newContent, setNewContent] = useState(content);
  const [newCover, setNewCover] = useState(cover);
  const [newPosition, setNewPosition] = useState(position);
  const [tagsArr, setTagsArr] = useState(tags);
  const [tag, setTag] = useState(null);
  const [openGallery, setOpenGallery] = useState(false);
  const [chosingCover, setChosingCover] = useState(false);
  const [fullCover, setFullCover] = useState(false);
  const [inputText, setInputText] = useState("");
  const [link, setLink] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedText, setSelectedText] = useState(null);

  const handleTextSelect = () => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      setSelectedText(range.toString());
    }
  };

  const handleTextChange = (e) => {
    setInputText(e.target.value);
  };

  const handleLinkChange = (e) => {
    setLink(e.target.value);
  };

  const handleInsert = (a) => {
    if (editorRef.current && link) {
      const editor = editorRef.current;
      let insertElement;
  
      if (selectedImage) {
        insertElement = `<a href="${link}" target="_blank"><img style="width: 100%; height: auto; object-fit: cover;  text-decoration: none;" src="${a}" alt="imagen"/></a>`;
      } else if (inputText) {
        insertElement = `<a href="${link}" target="_blank" style="color: rgb(205, 58, 58); font-weight: bold; text-decoration: none;">${inputText}</a>`;
      }
  
      if (insertElement) {
        editor.innerHTML += insertElement;
      }
  
      // ✅ Resetear todos los valores después de insertar
      setInputText("");
      setLink("");
      setSelectedImage(null);
      setGalleryForLink(false);
      setOpenGallery(false);
      setIsOpen(false);
    }
  };
  

  const openLinkModal = () => {
    setIsOpen(!isOpen);
    setOpenGallery(false);
    setGalleryForLink(false);
    setSelectedImage(null);
    setInputText("");
    setLink("");
  };
  

  const closeLinkModal = () => {
    setIsOpen(!isOpen);
    setOpenGallery(false);
    setGalleryForLink(false);
    setSelectedImage(null);
    setInputText("");
    setLink("");

  };

  const handleInputChange = (e) => {
    setLink(e.target.value); // Actualiza el valor de link
  };

  const handleSubmit = () => {
    const selection = window.getSelection();
    if (selection.rangeCount > 0 && selectedText) {
      const range = selection.getRangeAt(0);
      const a = document.createElement("a");
      a.href = link;
      a.textContent = selectedText;
      range.deleteContents();
      range.insertNode(a);
    }
    setIsOpen(false);
    setLink("");
  };

  //   useEffect(() => {
  //     if (editorRef.current) {
  //       setNewContent(editorRef.current.innerHTML);
  //     }
  //   }, [editorRef.current]);

  const saveSelection = () => {
    const editor = editorRef.current;
    if (editor) {
      const selection = window.getSelection();
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        if (editor.contains(range.commonAncestorContainer)) {
          return range;
        }
      }
    }
    return null;
  };

  const restoreSelection = (range) => {
    const editor = editorRef.current;
    if (editor && range) {
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      editor.focus();
    }
  };

  let savedRange = null;

  const openFullCover = () => {
    setFullCover(!fullCover);
  };

  const openGalleryF = () => {
    savedRange = saveSelection();
    setOpenGallery(!openGallery);
  };

  const openGalleryCover = () => {
    savedRange = saveSelection();
    openGalleryF();
    setChosingCover(!chosingCover);
  };

  const [galleryForLink, setGalleryForLink] = useState(false);

  const openGalleryLink = () => {
    setGalleryForLink(true);
    setSelectedImage(true);
    openGalleryF();
    setInsertImageMode(false);
    setChosingCover(false);
  };

  const choseCoverF = (e) => {
    setNewCover(e);
    openGalleryCover();
    setInsertImageMode(false);
    setChosingCover(false);
  };
  useEffect(() => {
    if (editorRef.current && content) {
      editorRef.current.innerHTML = content;
    }
  }, [content]);
  const handleInput = () => {
    if (editorRef.current) {
      thisArticle.body = editorRef.current.innerHTML;
    }
  };

  const handleSelectRelated = (selectedId) => {
    const selectedArticle = articles.find(
      (article) => article.id === selectedId
    );
    setNewRelated(selectedArticle);
  };

  // Obtener la fecha y hora actual
  useEffect(() => {
    if (!date) {
      const currentDate = new Date().toISOString().split("T")[0];
      setNewDate(currentDate);
    }
    if (!time) {
      const currentTime = new Date().toTimeString().split(" ")[0].slice(0, 5);
      setNewTime(currentTime);
    }
  }, []);

  const [relatedArr, setRelatedArr] = useState(related);

  let thisArticle = {
    subtitle: newSubtitle,
    category: newCategory,
    metaurl: newMetaurl,
    position: newPosition,
    title: newTitle,
    author: newAuthor,
    date: newDate,
    time: newTime,
    body: editorRef.current ? editorRef.current.innerHTML : content,
    cover: newCover,
    tags: newTagsArr,
    related: relatedArr.map((rel) => rel.id),
    created: created ? created : new Date(),
  };

  const positions = ["indefinida", "portada", "medio", "abajo"];

  const saveDraftF = () => {
    saveDraft(id);
  };

  const saveF = () => {
    save(id, thisArticle);
  };

  const [tagError, setTagError] = useState(false);

  const addTagToArr = () => {
    if (tag && tagsArr.length < 5) {
      const exists = tagsArr.some((e) => e === tag.toUpperCase());

      if (exists === true) {
        setTagError(true);
        setTimeout(() => {
          setTagError(false);
        }, 3000);
      } else if (exists !== true) {
        tagsArr.push(tag.toUpperCase());
        setRender(render + 1);
      } else {
        setTagError(true);
        setTimeout(() => {
          setTagError(false);
        }, 3000);
      }
    } else {
      setTagError(true);
      setTimeout(() => {
        setTagError(false);
      }, 3000);
    }
  };

  const deleteItem = (a) => {
    setTagsArr(tagsArr.filter((e) => e !== a));
  };

  const [relatedError, setRelatedError] = useState(false);

  const addRelatedToArr = () => {
    if (newRelated && newRelated.id && relatedArr.length < 3) {
      const exists = relatedArr.some((e) => e.id === newRelated.id);

      if (exists) {
        setRelatedError(true);
        setTimeout(() => {
          setRelatedError(false);
        }, 3000);
      } else {
        setRelatedArr([
          ...relatedArr,
          { id: newRelated.id, title: newRelated.title },
        ]);
      }
    } else {
      setRelatedError(true);
      setTimeout(() => {
        setRelatedError(false);
      }, 3000);
    }
  };

  const deleteRelated = (id) => {
    setRelatedArr(relatedArr.filter((e) => e.id !== id));
  };

  const [editorState, setEditorState] = useState(null);
  const [insertImageMode, setInsertImageMode] = useState(false);

  const insertImage = () => {
    let range = saveSelection();
    if (!range) {
      // Si no hay selección, coloca el cursor al final del contenido
      const editor = editorRef.current;
      if (editor) {
        editor.focus();
        range = document.createRange();
        range.selectNodeContents(editor);
        range.collapse(false);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
    }
    savedRange = range;
    setInsertImageMode(true);
    openGalleryF();
  };

  const insertImageF = (a) => {
    const editor = editorRef.current;
    if (editor) {
      if (savedRange) {
        restoreSelection(savedRange);
      } else {
        // Si no hay selección guardada, inserta al final
        const range = document.createRange();
        range.selectNodeContents(editor);
        range.collapse(false);
        const selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange(range);
      }
      const img = `<img style="width: 100%; height: auto; object-fit: cover;" src="${a}" alt="imagen" />`;
      document.execCommand("insertHTML", false, img);
      openGalleryCover();
      setInsertImageMode(false);
      setChosingCover(false);
    } else {
      console.error("El editor no está disponible");
    }
  };

  const insertLink = () => {
    const url = prompt("Introduce la URL del enlace:");
    if (url) {
      const selection = window.getSelection();
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        const selectedContent = range.extractContents();

        // Crear un nuevo elemento <a> y envolver el contenido seleccionado
        const link = document.createElement("a");
        link.href = url;
        link.appendChild(selectedContent);

        // Insertar el nuevo elemento <a> en el rango de selección
        range.insertNode(link);
      }
    }
  };

  const applyStyle = (style) => {
    document.execCommand(style, false, null);
  };

  const alignText = (alignment) => {
    document.execCommand("justify" + alignment, false, null);
  };

  const changeFontSize = (size) => {
    document.execCommand("fontSize", false, size + "px");
  };

  const changeLineHeight = (lineHeight) => {
    const selectedElement = window.getSelection().anchorNode.parentElement;
    selectedElement.style.lineHeight = lineHeight;
  };

  const lineHeights = [
    { value: "1", label: "Interlineado 1" },
    { value: "1.5", label: "Interlineado 1.5" },
    { value: "2", label: "Interlineado 2" },
  ];

  const wrapWithClass = () => {
    const editor = editorRef.current;
    const selection = window.getSelection();
    if (selection.rangeCount > 0) {
      const range = selection.getRangeAt(0);
      const selectedText = range.extractContents();

      const span = document.createElement("div");
      span.className = "destacado";
      span.appendChild(selectedText);

      range.insertNode(span);
    }
  };

  // // Función para hacer fetch de los artículos relacionados
  // const fetchRelatedArticles = async (relatedIds) => {
  //     try {
  //         const docRef = doc(db, "articles", id); // Reemplaza "collectionName" por el nombre de tu colección
  //         const docSnap = await getDoc(docRef);

  //         if (docSnap.exists()) {
  //           setThisArticleFetched(docSnap.data());
  //         } else {
  //           console.log("No such document!");
  //           setError("No such document!");
  //         }
  //     } catch (error) {
  //       console.error("Error fetching related articles: ", error);
  //       return [];
  //     }
  //   };

  const fetchRelatedArticles = async () => {
    try {
      if (!related || related.length === 0) {
        return [];
      }

      const relatedArticles = await Promise.all(
        related.map(async (docId) => {
          const docRef = doc(db, "articles", docId);
          const docSnap = await getDoc(docRef);

          if (docSnap.exists()) {
            return { id: docId, title: docSnap.data().title };
          } else {
            return null;
          }
        })
      );

      const filteredArticles = relatedArticles.filter(
        (article) => article !== null
      );

      return filteredArticles;
    } catch (error) {
      return [];
    }
  };

  // Uso en el componente
  useEffect(() => {
    const initializeRelatedArticles = async () => {
      if (related && related.length > 0) {
        const relatedArticles = await fetchRelatedArticles();

        setRelatedArr(relatedArticles);
      }
    };
    initializeRelatedArticles();
  }, [related]);

  return (
    <div className="text-editor">
      {added ? <p className="alert">¡Guardado!</p> : ""}
      {savedDraft ? <p className="alert">¡Guardado!</p> : ""}

      {openGallery ? (
        <GalleryModal
          galleryForLink={galleryForLink}
          handleInsert={handleInsert}
          openGallery={openGallery}
          openGalleryF={openGalleryF}
          uploadedShop={uploadedShop}
          alreadyExists={alreadyExists}
          uploadedZip={uploadedZip}
          uploadingZip={uploadingZip}
          handleChange={handleChange}
          handleUploadShopImage={handleUploadShopImage}
          chosingCover={chosingCover}
          choseCoverF={choseCoverF}
          insertImageMode={insertImageMode}
          insertImageF={insertImageF}
        />
      ) : (
        <></>
      )}
      <div className="text-editor-topbar">
        <div className="row-center gap05rem">
          {/* <InputWlabel
            att="subtitle"
            type="text"
            label="Título"
            column={true}
            onChange={(e) => setTitle(e.target.value)}
          /> */}

          <input
            className="text-editor-topbar-input"
            placeholder="Título"
            type="text"
            value={newTitle}
            onChange={(e) => setNewTitle(e.target.value)}
          />
        </div>
        <div className="row-center gap05rem">
          {/* <button
            onClick={savingDraft ? undefined : saveDraftF}
            className="text-editor-topbar-button"
          >
            {savingDraft ? "Guardando..." : "Guardar como borrador"}
          </button> */}

          <a className="buttonbyn" target="_blank" href={`/article/${id}`}>
            VER
          </a>
          <button onClick={saveF} className="text-editor-topbar-button">
            {adding ? "Guardando..." : "Guardar"}
          </button>
        </div>
      </div>

      <div className="editor-toolbar">
        <button onClick={() => applyStyle("bold")}>
          <img
            width="15"
            height="15"
            src="https://img.icons8.com/ios-filled/50/ffffff/bold.png"
            alt="bold"
          />
        </button>
        <button onClick={() => applyStyle("italic")}>
          <img
            width="15"
            height="15"
            src="https://img.icons8.com/ios-filled/50/ffffff/italic.png"
            alt="italic"
          />
        </button>
        <button onClick={() => applyStyle("underline")}>
          <img
            width="15"
            height="15"
            src="https://img.icons8.com/ios-filled/50/ffffff/underline.png"
            alt="underline"
          />
        </button>
        <button onClick={() => alignText("Left")}>
          <img
            width="15"
            height="15"
            src="https://img.icons8.com/ios-filled/50/ffffff/align-left.png"
            alt="align-left"
          />
        </button>
        <button onClick={() => alignText("Center")}>
          <img
            width="15"
            height="15"
            src="https://img.icons8.com/ios-filled/50/ffffff/align-center.png"
            alt="align-left"
          />
        </button>
        <button onClick={() => alignText("Right")}>
          <img
            width="15"
            height="15"
            src="https://img.icons8.com/ios-filled/50/ffffff/align-right.png"
            alt="align-left"
          />
        </button>
        <button onClick={() => alignText("Full")}>
          <img
            width="15"
            height="15"
            src="https://img.icons8.com/ios-filled/50/ffffff/align-justify.png"
            alt="align-justify"
          />
        </button>

        <select onChange={(e) => changeFontSize(e.target.value)}>
          <option value="1">10</option>
          <option value="2">13</option>
          <option value="3" selected>
            16
          </option>
          <option value="4">18</option>
          <option value="5">24</option>
          <option value="6">32</option>
          <option value="7">48</option>
        </select>

        <select onChange={(e) => changeLineHeight(e.target.value)}>
          {lineHeights.map((lineHeight) => (
            <option key={lineHeight.value} value={lineHeight.value}>
              {lineHeight.label}
            </option>
          ))}
        </select>

        <div>
          <button onClick={wrapWithClass}>Destacar texto</button>
          {/* Aquí iría tu botón de "Agregar link" */}
        </div>

        <button onClick={isOpen ? closeLinkModal : openLinkModal}>
          <img
            width="15"
            height="15"
            src="https://img.icons8.com/ios-filled/50/ffffff/link--v1.png"
            alt="attach"
          />
        </button>
        <button onClick={insertImage}>
          <img
            width="15"
            height="15"
            src="https://img.icons8.com/ios-filled/50/ffffff/image.png"
            alt="image"
          />
        </button>
        {/* <button className="text-editor-topbar-button" onClick={insertImage}>
          Insertar Imagen
        </button>
        <button className="text-editor-topbar-button" onClick={insertLink}>
          Insertar Enlace
        </button> */}
      </div>

      <div className="editor-cover-text-data-cont">
        <div className="editor-cover-text-data-left ">
          <div
            onClick={newCover.length === 0 ? openGalleryCover : null}
            className={`editor-front-img-upload ${
              newCover.length > 1 ? "h450px" : ""
            } `}
          >
            {newCover.length > 1 ? (
              <>
                <img
                  onClick={openFullCover}
                  className="full-screen-button"
                  width="20"
                  height="20"
                  src="https://img.icons8.com/fluency-systems-regular/48/fullscreen.png"
                  alt="fullscreen"
                />
                <p
                  className="buttonbyn change-cover-button"
                  onClick={openGalleryCover}
                >
                  Modificar portada
                </p>
                <img
                  width="20"
                  height="20"
                  src="https://img.icons8.com/ios/50/5a5a5a/image--v1.png"
                  alt="image--v1"
                />
                <img
                  className={`editor-cover-uploaded ${
                    fullCover ? "coverFull" : ""
                  }`}
                  src={newCover}
                  alt=""
                />
              </>
            ) : (
              <>
                <p>Elegir portada</p>
                <img
                  width="20"
                  height="20"
                  src="https://img.icons8.com/ios/50/5a5a5a/image--v1.png"
                  alt="image--v1"
                />
              </>
            )}
          </div>
          <InputWlabel
            att="subtitle"
            type="text"
            label="Bajada"
            column={true}
            value={newSubtitle}
            edit={true}
            onchange={(e) => setNewSubtitle(e.target.value)}
          />
          <div
            id="document"
            ref={editorRef}
            contentEditable="true"
            className="editor-content"
            onInput={handleInput}
            onMouseUp={handleTextSelect}
            onClick={() => editorRef.current.focus()}
          >
            &#8203; {/* Carácter de ancho cero */}
          </div>
        </div>

        <div className="editor-content-sidebar">
          <InputWlabel
            att="author"
            label="Autor"
            column={true}
            options={true}
            array={authors}
            value={newAuthor}
            edit={true}
            fromDB={true}
            onchange={(e) => setNewAuthor(e.target.value)}
          />

          <InputWlabel
            att="category"
            label="Categoría"
            column={true}
            options={true}
            array={categories}
            value={newCategory}
            edit={true}
            fromDB={true}
            onchange={(e) => setNewCategory(e.target.value)}
          />

          <InputWlabel
            att="position"
            label="Ubicación"
            column={true}
            onchange={(e) => setNewPosition(e.target.value)}
            options={true}
            value={newPosition}
            edit={true}
            array={positions}
          />

          <InputWlabel
            att="date"
            type="date"
            label="Fecha"
            column={true}
            value={newDate}
            edit={true}
            onchange={(e) => setNewDate(e.target.value)}
          />
          <InputWlabel
            att="time"
            type="time"
            label="Hora"
            column={true}
            value={newTime}
            edit={true}
            onchange={(e) => setNewTime(e.target.value)}
          />
          <InputWlabel
            att="tags"
            type="text"
            label="Tags (máx. 10)"
            column={true}
            onchange={(e) => setTag(e.target.value)}
          />
          <button onClick={addTagToArr} className="text-editor-topbar-button">
            {" "}
            Agregar{" "}
          </button>
          {tagsArr.length > 0 ? (
            <div className="row w100 flex-wrap gap025rem">
              {tagsArr.map((e, index) => (
                <button
                  onClick={() => {
                    deleteItem(e);
                  }}
                  className="text-editor-topbar-button minibutton"
                  key={index}
                >
                  {" "}
                  {e}{" "}
                </button>
              ))}
            </div>
          ) : (
            <></>
          )}
          {/* <InputWlabel
            att="related"
            type="text"
            label="Relacionadas"
            column={true}
            options={true}
            array={articles}
            onchange={(e) => setRelated(e.target.value)}
          /> */}

          <div className={`inputWlabel column-flex-start`}>
            <label className="inputwlabel-label" htmlFor="related">
              {" "}
              Relacionadas{" "}
            </label>

            <select
              onChange={(e) => handleSelectRelated(e.target.value)}
              className="inputwlabel-input"
            >
              <option value="">Máx 3.</option>
              {articles ? (
                articles.map((article, index) => (
                  <option
                    className="inputwlabel-input"
                    key={index}
                    value={article.id}
                  >
                    {article.title.toUpperCase()}
                  </option>
                ))
              ) : (
                <></>
              )}
            </select>
          </div>

          <button
            onClick={related ? addRelatedToArr : undefined}
            className="text-editor-topbar-button"
          >
            {" "}
            Agregar{" "}
          </button>
          {relatedArr.length > 0 ? (
            <div className="column gap05rem">
              {relatedArr.map((item, index) => (
                <div className="text-editor-related-item" key={index}>
                  <p className="text-editor-related-item-text">{item.title}</p>

                  <img
                    className="text-editor-related-item-icon"
                    onClick={() => deleteRelated(item.id)}
                    width="25"
                    height="25"
                    src="https://img.icons8.com/ios-glyphs/30/ffffff/filled-trash.png"
                    alt="filled-trash"
                  />
                </div>
              ))}
            </div>
          ) : (
            <></>
          )}
          {/* 
<div>
    <img src={cover} alt="" />
    <p> {title} </p>
  </div> */}
        </div>
      </div>

      {isOpen && (
        <div className="link-modal">
          <div className={`inputWlabel column-flex-start w200px`}>
            <label className="inputwlabel-label" htmlFor="">
              Texto (no es necesario si inserta una imagen)
            </label>
            <input
              className="inputwlabel-input"
              type="text"
              placeholder="Ingrese el texto"
              value={inputText}
              onChange={handleTextChange}
            />
            <label className="inputwlabel-label" htmlFor="">
              URL
            </label>
            <input
              type="text"
              className="inputwlabel-input"
              placeholder="Ingrese el link"
              value={link}
              onChange={handleLinkChange}
            />
            <label className="inputwlabel-label" htmlFor="">
              Para ingresar una imagen, primero define la URL
            </label>
            <button
              onClick={link ? openGalleryLink : undefined}
              className="buttonbyn"
            >
              Insertar imagen con link
            </button>
            <button className="buttonbyn" onClick={handleInsert}>
              Insertar
            </button>
            <button className="buttonbyn" onClick={closeLinkModal}>
              Cancelar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
